export const TOOLTIPS = {
  designPrivacy: `
    This option allows you to keep your entry hidden from the other participants
    until the start of the Community Vote. You can activate this option only if
    you publish your project within the first half of the Upload phase. This
    option is not available for private gallery contests.
  `,
  designAbstract: `
    Please explain your project abstract clearly and concisely. This will help others understand the essence of your design.
  `,
  designDescription: `
    Describe your design in a deep way. Tell us the reason of your choice, motivations and everything you think could be useful to understand your project better.
  `,
  designCoverImage: `
    The cover image is the first thing people will see when they visit your project page.
    Choose an image that best represents your design and captures attention.
  `,
  designPayoff: `
    Write a Payoff / Slogan to give more relevance to your Project name and say something more about the brand. Remember to use a few words. Example: Project name: Desall , Payoff: Design on-demand.
  `,

  projectName: `
    Identify your project with a unique name. This will be visible to the public
    and should be clear, concise, and representative of your design.
  `,

  countryPrivacy: `
    Your selected country will be visible only to the contest organizer and will
    not be shared publicly.
  `,

  // Add more tooltips here...
} as const;

export type TooltipKey = keyof typeof TOOLTIPS;
